import { UserProfile } from './core/models/user';
import { PwaService } from './core/services/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MasterHelper } from './core/utilities/master-helper';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { CommonService } from 'src/app/core/services/common/common.service';
import { ThemeGetModel } from './core/models/user-management/get-theme-details-model';
import { UserManagementService } from './core/services/user-management/user-management.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit, OnDestroy {
  title = 'finreg-e';
  isLoggedIn: any;
  isLoadingMenu = false;
  currentUser!: UserProfile;
  isShowFooter = false;
  imageSrc: string | null = null;
  bannerSrc: string | null = null;
  themeDetails!: ThemeGetModel;
  shouldAddClassDefault = false;
  shouldAddClassRed = false;
  shouldAddClassBlue = false;
  shouldAddClassOrange = false;
  bannerAddress: string = '';
  actionColor: any;
  baseColor: any;
  image: string | null = null;
  banner: string | null = null;
  color: string | null = null;

  constructor(
    public authService: AuthService,
    public pwaService: PwaService,
    public commonService: CommonService,
    private userService: UserManagementService
  ) {
    this.isLoggedIn = this.authService.isLoggedIn;
    this.pwaService.installPwa();
  }


  ngOnInit(): void {
    this.image = localStorage.getItem('imageSrc');
    this.banner = localStorage.getItem('bannerSrc');
    this.color = localStorage.getItem('themeColor');
    if (this.image != null && this.banner != null && this.color != null) {
      this.settingTheme(this.image, this.banner, this.color);
    }
    else {
      const bodyTag = document.body;
      this.userService.getThemeDetails().subscribe(
        (data: ThemeGetModel) => {
          this.themeDetails = data;
          if (this.themeDetails && (this.themeDetails.image != "" || this.themeDetails.banner != "" || this.themeDetails.color != "")) {
            this.imageSrc = `data:image/png;base64,${this.themeDetails.image}`;
            this.bannerSrc = `data:image/jpg;base64,${this.themeDetails.banner}`;
            localStorage.setItem('imageSrc', this.imageSrc);
            localStorage.setItem('bannerSrc', this.bannerSrc);
            localStorage.setItem('themeColor', this.themeDetails.color);
            let root = document.querySelector(':root') as HTMLElement;
            if (this.themeDetails.color == "#4a1c9499") {
              if (bodyTag.classList.contains("myClass")) {
                bodyTag.classList.remove('myClass');
                bodyTag.classList.add('defaultClass');
              }
              else {
                bodyTag.classList.add('defaultClass');
              }
              root.style.setProperty('--dynamic-background-color', this.themeDetails.color);
              this.actionColor = "#9278bf3b";
              this.baseColor = "#441c89";
              root.style.setProperty('--dynamic-actionbckground-color', this.actionColor);
              root.style.setProperty('--dynamic-baseaction-color', this.baseColor);
            }
            else {
              bodyTag.classList.add('myClass');
              root.style.setProperty('--dynamic-background-color', this.themeDetails.color);
              this.actionColor = this.lightenHexColor(this.themeDetails.color, 15);
              this.baseColor = this.lightenHexColor(this.themeDetails.color, 87);
              root.style.setProperty('--dynamic-actionbckground-color', this.actionColor);
              root.style.setProperty('--dynamic-baseaction-color', this.baseColor);
            }
          }
          else {
            const formData = new FormData();
            this.userService.addTheme(formData, true).subscribe((res: any) => {
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        (error) => {
          console.error('Error fetching theme details:', error);
        });
    }

    this.isShowFooter = (MasterHelper.fetchFromBrowser('_fpp') != null &&
      MasterHelper.fetchFromBrowser('_fpp') === 'accept') ? false : true;
    this.checkLoggedIn();
  }

  ngOnDestroy(): void { }

  installPwa(): void {
    this.pwaService.installPwa();
  }
  settingTheme(img: string, ban: string, col: string) {
    this.imageSrc = img;
    this.bannerSrc = ban;
    const bodyTag = document.body;
    bodyTag.classList.add('myClass');
    let root = document.querySelector(':root') as HTMLElement;
    if (col == "#4a1c9499") {
      if (bodyTag.classList.contains("myClass")) {
        bodyTag.classList.remove('myClass');
        bodyTag.classList.add('defaultClass');
      }
      else {
        bodyTag.classList.add('defaultClass');
      }
      root.style.setProperty('--dynamic-background-color', col);
      this.actionColor = "#9278bf3b";
      this.baseColor = "#9278bf";
      root.style.setProperty('--dynamic-actionbckground-color', this.actionColor);
      root.style.setProperty('--dynamic-baseaction-color', this.baseColor);
    }
    else {
      root.style.setProperty('--dynamic-background-color', col);
      this.actionColor = this.lightenHexColor(col, 15);
      this.baseColor = this.lightenHexColor(col, 87);
      root.style.setProperty('--dynamic-actionbckground-color', this.actionColor);
      root.style.setProperty('--dynamic-baseaction-color', this.baseColor);
    }
  }
  lightenHexColor(hex: string, percentage: number): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const newHex = `rgba(${r}, ${g}, ${b}, ${percentage / 100})`;
    return newHex;
  }


  setPrivacyPolicy(): void {
    this.isShowFooter = false;
    MasterHelper.saveOnBrowser('_fpp', 'accept');
  }

  checkLoggedIn(): void {
    this.authService.isLoggedInSuccess().subscribe(() => {
    }, (err: any) => {
      this.authService.logOut();
    });
  }
}
